export default {
  'WorkOrderTableRow.Wrapper': ({ }, outlet) => {
    outlet({ action: 'open_modal' });
  },
  'WorkOrderTableRow.Wrapper.Category.Checkbox': ({ }, outlet) => {
    outlet({ action: 'select_order' });
  },
  'WorkOrderTableRow.Wrapper.User.Unit': ({ order }, outlet) => {
    if (order.status === 'unassigned' && order?.tenancy_id) {
      window.location.href = `/tenants/${order?.tenancy_id}`;
      return;
    }

    if (order.status === 'assigned' || order.status === 'completed') {
      if (order.tech_id) {
        window.location.href = `/techs/${order.tech_id}`;
        return;
      }
      if (order.vendor_id) {
        window.location.href = `/vendors/${order.vendor_id}`;
        return;
      }
    }
    outlet({ action: 'open_modal' });
  },
  'WorkOrderTableRow.Wrapper.LocationCell.Unit': ({ order }) => {
    if (order.unit_id) {
      window.location.href = `/units/${order.unit_id}`;
    }
  },
  'WorkOrderTableRow.Wrapper.Level': () => {
    // TODO: What goes here????
  }
}